import styled from 'styled-components';

import { MultipleChoiceLetter } from '../multiple-choice.style';
import { MultipleChoiceEditInput } from '../multiple-choice-edit.style';
import { rem } from 'approot/shared/style';

export const MultipleChoiceEditList = styled.div`
  // remove 2px right padding to cater for border around
  // the input field
  ${MultipleChoiceLetter} {
    margin-right: ${rem(10)};
  }

  ${MultipleChoiceEditInput} {
    border: none;
  }
`;
